module.exports = __webpack_public_path__ + "static/media/cactus2.9d952612.svg";